import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

import "./Header.css";
import { useAssets } from "../../assets/AssetsContext";
import "../styles/styles.css";

function Header() {
  const assets = useAssets();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState("");
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const toggleMenu = () => setMenuOpen(!isMenuOpen);
  const closeMenu = () => {
    setMenuOpen(false);
    setOpenSubmenu("");
    window.scrollTo(0, 0);
  };

  const toggleSubmenu = (menu) => {
    setOpenSubmenu(openSubmenu === menu ? "" : menu);
  };

  useEffect(() => {
    if (isMenuOpen) {
      if (location.pathname.startsWith("/sustainability")) {
        setOpenSubmenu("sustainability");
      } else if (location.pathname.startsWith("/climate")) {
        setOpenSubmenu("climate");
      } else if (location.pathname.startsWith("/customers")) {
        setOpenSubmenu("customers");
      } else if (location.pathname.startsWith("/company")) {
        setOpenSubmenu("company");
      } else if (location.pathname.startsWith("/resources")) {
        setOpenSubmenu("resources");
      } else {
        setOpenSubmenu("");
      }
    }
  }, [isMenuOpen, location.pathname]);

  return (
    <div className="header-fixed">
      <div className="wrapper">
        <header className="header">
          <div className="logo">
            {/* <img src={assets.logo} alt="Logo" /> */}
            <Link to="/">
              <img src={isHomePage ? assets.logo : assets.logo2} alt="Logo" />
            </Link>
          </div>
          {/* ☰  */}
          <button className="hamburger" onClick={toggleMenu}>
            <img src={assets.Hamburger} alt="Hamburger" />
          </button>

          <div className={`menu-overlay ${isMenuOpen ? "open" : ""}`}>
            <button className="close-btn" onClick={closeMenu}>
              ×
            </button>
            <nav className="menu">
              <ul>
                <li onClick={closeMenu}>
                  <NavLink
                    to="/"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Home
                  </NavLink>
                </li>

                {/* Sustainability Intelligence */}
                {/* <li>
                  <span
                    onClick={() => toggleSubmenu("sustainability")}
                    className={
                      location.pathname.startsWith("/sustainability")
                        ? "active"
                        : ""
                    }
                  >
                    Sustainability Intelligence
                  </span>
                  {openSubmenu === "sustainability" && (
                    <ul className="submenu">
                      
                    </ul>
                  )}
                </li> */}

                {/* Climate Engineering */}
                <li>
                  <span
                    onClick={() => toggleSubmenu("climate")}
                    className={
                      location.pathname.startsWith("/climate") ? "active" : ""
                    }
                  >
                    Climate Engineering
                  </span>
                  {openSubmenu === "climate" && (
                    <ul className="submenu">
                      <li onClick={closeMenu}>
                        <NavLink to="/climate/HydroTRACE">HydroTRACE</NavLink>
                      </li>
                      <li onClick={closeMenu}>
                        <NavLink to="/climate/bioforge">BioFORGE</NavLink>
                      </li>
                      <li onClick={closeMenu}>
                        <NavLink to="/climate/AtmosPOD">AtmosPOD</NavLink>
                      </li>
                      <li onClick={closeMenu}>
                        <NavLink to="/climate/acceltrack">AccelTRACK</NavLink>
                      </li>
                      <li onClick={closeMenu}>
                        <NavLink to="/climate/accelalert">AccelALERT</NavLink>
                      </li>
                      <li onClick={closeMenu}>
                        <NavLink to="/climate/accelsupply">AccelSUPPLY</NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Customers */}
                {/* <li>
                  <span
                    onClick={() => toggleSubmenu("customers")}
                    className={
                      location.pathname.startsWith("/customers") ? "active" : ""
                    }
                  >
                    Customers
                  </span>
                  {openSubmenu === "customers" && (
                    <ul className="submenu">
                      <li onClick={closeMenu}>
                        <NavLink to="/customers/voice">
                          Voice of the Customer
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li> */}
                <li onClick={closeMenu}>
                  <NavLink
                    to="/TheFifthClimate"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    The Fifth Climate
                  </NavLink>
                </li>

                {/* Company */}
                <li>
                  <span
                    onClick={() => toggleSubmenu("company")}
                    className={
                      location.pathname.startsWith("/company") ? "active" : ""
                    }
                  >
                    Company
                  </span>
                  {openSubmenu === "company" && (
                    <ul className="submenu">
                      <li onClick={closeMenu}>
                        <NavLink to="/company/about">About Us</NavLink>
                      </li>
                      <li onClick={closeMenu}>
                        <NavLink to="/company/contact">Contact Us</NavLink>
                      </li>
                      <li onClick={closeMenu}>
                        <NavLink to="/company/green-pledge">
                          Green Pledge
                        </NavLink>
                      </li>
                      <li onClick={closeMenu}>
                        <NavLink to="/company/leadership">Leadership</NavLink>
                      </li>
                      <li onClick={closeMenu}>
                        <NavLink to="/company/careers">Careers</NavLink>
                      </li>
                      <li onClick={closeMenu}>
                        <NavLink to="/company/privacy">Privacy Policy</NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                {/* Resources */}
                <li>
                  <span
                    onClick={() => toggleSubmenu("resources")}
                    className={
                      location.pathname.startsWith("/resources") ? "active" : ""
                    }
                  >
                    Resources
                  </span>
                  {openSubmenu === "resources" && (
                    <ul className="submenu">
                      <li onClick={closeMenu}>
                        <NavLink to="/resources/blogs">Blogs</NavLink>
                      </li>
                      <li onClick={closeMenu}>
                        <NavLink to="/resources/news">Latest News</NavLink>
                      </li>
                      <li onClick={closeMenu}>
                        <NavLink to="/resources/events">Events</NavLink>
                      </li>
                    </ul>
                  )}
                </li>
              </ul>
            </nav>
          </div>
        </header>
      </div>
    </div>
  );
}

export default Header;
